import {
  gridColumnDefinitionsSelector,
  gridFilterModelSelector,
  gridSelectionStateSelector,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-pro';
import { FC } from 'react';
import { TableRoofProps } from '../tables/presentation/table/roofs';
import { BaseRoof } from '../tables/presentation/table/roofs/base';
import { TableDataGridFilter } from './filter';

type Props = {
  threePointMenuConfig: TableRoofProps['threePointMenuConfig'];
  actionButtonConfig: TableRoofProps['actionButtonConfig'];
  additionalComponent?: JSX.Element;
  customTableRoofHeadline?: string;
};

export const TableDataGridActionBar: FC<Props> = ({
  threePointMenuConfig,
  actionButtonConfig,
  additionalComponent,
  customTableRoofHeadline
}) => {
  const apiRef = useGridApiContext();
  const countOfEntries = apiRef.current.getRowsCount();
  const selectedRowIds = useGridSelector(apiRef, gridSelectionStateSelector);

  const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  const filterableColumns = columns.filter((c) => c.filterable);
  const hasFilterableColumns = filterableColumns.length > 0;

  const filter = useGridSelector(apiRef, gridFilterModelSelector);
  const chips = filter.items.map((item) => ({
    label: item.value,
    onDelete: () => apiRef.current.deleteFilterItem(item)
  }));

  const onSearch = (value?: string) => {
    apiRef.current.setQuickFilterValues([value]);
  };

  const onDeselect = () => {
    apiRef.current.setSelectionModel([]);
  };

  const renderFilter = () => <TableDataGridFilter />;

  return (
    <BaseRoof
      countOfEntries={countOfEntries}
      selectedRowIds={selectedRowIds}
      onSearch={onSearch}
      renderFilter={hasFilterableColumns ? renderFilter : undefined}
      additionalComponent={additionalComponent}
      customTableRoofHeadline={customTableRoofHeadline}
      chips={chips || []}
      onDeselect={onDeselect}
      threePointMenuConfig={threePointMenuConfig}
      actionButtonConfig={actionButtonConfig}
    />
  );
};
